export class ActiveFixedProfeaturEntity {

    id:number;
    productId:number;
    featuresId: number;
    serial: string;

constructor() { }
}